import React, { Fragment } from "react";
import { Row } from "reactstrap";
import { Colxx } from "../../../../../../../components/common/CustomBootstrap";
import SummaryStatistics from "./SummaryStatistics";
import WhatsAppGraph from "./WhatsAppGraph";
import SMSGraph from "./SMSGraph";
import EmailGraph from "./EmailGraph";

const MessageGraph = ({ 
  apiData = [], 
  fromDate = null, 
  toDate = null, 
  isYearMonthView = false,
  children = null 
}) => {
  return (
    <Fragment>
      <SummaryStatistics apiData={apiData} />

      <Row className="mb-4">
        <Colxx xxs="12" md="6" className="mb-3">
          <WhatsAppGraph 
            apiData={apiData} 
            fromDate={fromDate}
            toDate={toDate}
            isYearMonthView={isYearMonthView}
          />
        </Colxx>
        <Colxx xxs="12" md="6" className="mb-3">
          <SMSGraph 
            apiData={apiData} 
            fromDate={fromDate}
            toDate={toDate}
            isYearMonthView={isYearMonthView}
          />
        </Colxx>
      </Row>

      <Row className="mb-4">
        <Colxx xxs="12" md="6" className="mb-3">
          <EmailGraph 
            apiData={apiData} 
            fromDate={fromDate}
            toDate={toDate}
            isYearMonthView={isYearMonthView}
          />
        </Colxx>
      </Row>

      {children && <Fragment>{children}</Fragment>}
    </Fragment>
  );
};

export default MessageGraph;